<template>
  <div class="tree-grid">
    <div class="tree-grid-container" ref="treeGridContainer">
      <table>
        <thead class="tree-grid-thead">
          <tr>
            <slot/>
          </tr>
        </thead>
        <tbody>
          <slot name="rows" />
          <tr
            v-for="(row, rowIndex) in data"
            :key="`row-${rowIndex}`"
          >
            <td
              v-for="(component, columnIndex) in $slots.default.filter(c => c.tag && c.tag.includes('TreeGrid'))"
              :key="`row-${rowIndex}-column-${columnIndex}`"
            >
              <TreeGridRow
                v-model="row[component.componentOptions.propsData.field]"
                :node="component.componentOptions.children"
                :align="component.componentOptions.propsData.align"
                :item="row"
                :columnIndex="columnIndex"
                :rowIndex="rowIndex"
                :deep="row._deep"
                :expanded="row._expanded"
                :hasItems="hasItems(row)"
                @expand="handleExpand(row, rowIndex)"
                @close="handleClose(row, rowIndex)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// Child components
import TreeGridRow from './TreeGridRow.vue'

// Mixins
import {
  usePageMixin,
  useEventBuilderMixin } from './mixins'

// Constants
import { EVENT_NAME_CLICK, EVENT_NAME_DOUBLE_CLICK } from './constants/events'

export default {
  name: 'TreeGrid',
  components: {
    TreeGridRow
  },
  mixins: [
    usePageMixin,
    useEventBuilderMixin
  ],
  props: {
    hasItems: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      settings: {
        showPager: null
      }
    }
  },
  methods: {
    onClick (nativeEvent, index, columnIndex, fieldName) {
      const eventOptions = {
        nativeEvent,
        index
      }

      if (index >= 0) {
        eventOptions.item = this.data[index]

        if (fieldName) {
          eventOptions.columnClick = {
            index: columnIndex,
            field: fieldName,
            value: this.data[index][fieldName]
          }
        }
      }

      this.$emit(EVENT_NAME_CLICK, this.buildEvent(EVENT_NAME_CLICK, eventOptions))
    },
    onDoubleClick (nativeEvent, index, columnIndex, fieldName) {
      const eventOptions = {
        nativeEvent,
        index
      }

      if (index >= 0) {
        eventOptions.item = this.data[index]

        if (fieldName) {
          eventOptions.columnClick = {
            index: columnIndex,
            field: fieldName,
            value: this.data[index][fieldName]
          }
        }
      }

      this.$emit(EVENT_NAME_DOUBLE_CLICK, this.buildEvent(EVENT_NAME_DOUBLE_CLICK, eventOptions))
    },
    async reload () {
      await this.handleLoad(this.internalLoad)
    },
    async reloadItem (item, index) {
      if (item._parentId === null) {
        this.handleLoad(this.internalLoad)
      } else if (this.$props.hasItems(item) && item._expanded) {
        this.handleClose(item, index)

        await this.$nextTick(async () => {
          await this.handleExpand(item, index)
        })
      }
    },
    async handleExpand (item, index) {
      const deep = item._deep + 1
      const items = await this.internalLoadRelated(item, deep)

      this.data.splice(index + 1, 0, ...items)
      item._expanded = true
    },
    handleClose (item, index) {
      let total = this.getTotalChildren(item[this.itemKey])

      this.data.splice(index + 1, total)
      item._expanded = false
    },
    getTotalChildren (parentId) {
      const children = this.data.filter(item => item._parentId === parentId)
      let total = children.length

      children.forEach(child => {
        total += this.getTotalChildren(child[this.itemKey])
      })

      return total
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treegrid/TreeGrid.vue